import styled, { css } from "styled-components";

export const StyledSidebarContainer = styled.div`
  opacity: ${({ expand }) => (expand ? 1 : 0)};
  transition: opacity 0.3s ease-in-out;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  padding-bottom: 10px;
  overflow: hidden;
  position: absolute;
  box-sizing: border-box;
`;

export const StyledSidebarTitle = styled.span`
  font-size: 17px;
  color: var(--fontColor);
  display: inline-block;
  white-space: nowrap;
  line-height: normal;
`;

export const StyledConopsContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 8px;
  text-align: left;
  /* margin-top: 4px; */
  padding: 4px 8px;
  overflow: auto;
`;

export const StyledConopsItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: rgba(255, 255, 255, 0.5);

  padding: 8px 8px 8px;
  border-radius: 8px;
`;

export const StyledTitleContainer = styled.span`
  min-height: 33px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 4px;
  box-sizing: border-box;

  span {
    font-size: 13px;
  }
`;

export const StyledIconContainer = styled.div`
  width: ${({ width }) => (width ? `${width}px` : "28px")};
  height: ${({ height }) => (height ? `${height}px` : "28px")};
  min-width: ${({ width }) => (width ? `${width}px` : "28px")};

  img {
    width: ${({ width }) => (width ? `${width}px` : "28px")};
    height: ${({ height }) => (height ? `${height}px` : "28px")};
    min-width: ${({ width }) => (width ? `${width}px` : "28px")};
    object-fit: contain;
  }
`;

export const StyledDescriptionContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 4px;
  position: relative;

  /* Animation styles */
  padding-top: 2px;
  max-height: 1000px; /* Should be large enough for your content */
  opacity: 1;
  transition: max-height 0.3s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s;

  span {
    font-size: 12px;
    color: var(--fontColor);
    line-height: normal;
  }

  ${({ selected }) =>
    !selected &&
    css`
      padding-top: 0px;
      max-height: 0;
      opacity: 0;
      overflow: hidden;
      transition: max-height 0s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.2s;
    `}
`;

export const StyledFooterContainer = styled.div`
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  justify-content: center;
  padding: 0px 8px;
`;
